import { useThemeContextSelector } from "@/utils/theme";
import { themeColors } from "@/utils/themeColors";
import { HTMLProps } from "react";
import { editorThemeColors } from "../../utils/editorThemeColors";

export type SurfaceProps = HTMLProps<HTMLDivElement> & {
    withShadow?: boolean;
    withBorder?: boolean;
};

export const Surface = ({
    ref,
    children,
    style,
    ...props
}: SurfaceProps & {
    ref?: React.RefObject<HTMLDivElement | null>;
}) => {
    const isDarkMode = useThemeContextSelector(state => state.isDarkMode);

    const boxShadow = isDarkMode
        ? {
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.8)",
          }
        : {
              "--tw-shadow": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
              "--tw-shadow-colored": "0 1px 2px 0 var(--tw-shadow-color)",
              boxShadow: "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
          };

    const surfaceStyle = {
        backgroundColor: editorThemeColors.background,
        borderRadius: "5px",
        borderWidth: "0.1rem",
        borderStyle: "solid",
        borderColor: themeColors.neutral1,
        ...boxShadow,
        ...style,
    };

    return (
        <div style={surfaceStyle} {...props} ref={ref}>
            {children}
        </div>
    );
};
